var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.208 13.072c-.908.092-2.261.193-3.728.193c-1.54 0-2.891-.113-4.016-.341c-3.035-.612-5.988-2.577-7.467-3.683c-1.477 1.105-4.426 3.068-7.463 3.683c-1.126.228-2.477.341-4.017.341c-1.463 0-2.819-.104-3.723-.193c-1 2.52-3.39 9.775-1.947 18.683C16.692 43.158 28.734 52.495 32 54.839c3.267-2.344 15.309-11.681 17.152-23.084c1.44-8.907-.944-16.161-1.944-18.683m-17.873-.066a26.697 26.697 0 0 0 2.664-1.592a26.699 26.699 0 0 0 2.669 1.592v11.279h-5.333V13.006m5.333 37.465A57.213 57.213 0 0 1 32 52.637a59.734 59.734 0 0 1-2.665-2.164V31.344h5.333v19.127m12.872-20.01H16.461a34.072 34.072 0 0 1-.276-5.294h31.629a34.19 34.19 0 0 1-.274 5.294",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.445 8.325a3.373 3.373 0 0 0-3.037-1.883c-.162 0-.325.011-.486.034c-.02.004-2.164.305-4.539.305c-1.328 0-2.453-.092-3.343-.271c-3.226-.65-6.795-3.664-6.831-3.694a3.401 3.401 0 0 0-4.416-.001c-.035.029-3.609 3.044-6.831 3.694c-.891.18-2.016.271-3.344.271c-2.383 0-4.519-.301-4.54-.305a3.601 3.601 0 0 0-.481-.033a3.381 3.381 0 0 0-3.039 1.877c-.539 1.108-5.127 11.043-2.998 24.22c2.651 16.37 20.813 28.404 21.585 28.908a3.392 3.392 0 0 0 3.712-.002c.771-.503 18.938-12.539 21.585-28.905c2.195-13.567-2.784-23.787-2.997-24.215m1.243 23.935c-2.526 15.612-20.063 27.226-20.81 27.713a1.606 1.606 0 0 1-1.755 0c-.747-.487-18.279-12.101-20.808-27.713c-2.1-12.997 2.636-22.746 2.834-23.155a1.618 1.618 0 0 1 1.672-.881c.022.003 2.275.322 4.796.322c1.449 0 2.693-.104 3.698-.307c3.71-.748 7.599-4.054 7.638-4.087a1.616 1.616 0 0 1 2.097 0c.038.033 3.921 3.339 7.636 4.087c1.005.203 2.246.307 3.697.307c2.521 0 4.771-.319 4.795-.322a1.616 1.616 0 0 1 1.672.881c.204.409 4.939 10.158 2.838 23.155",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.001,
    cy: 6.523,
    rx: 1.228,
    ry: 1.236,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.771,
    cy: 10.852,
    rx: 1.229,
    ry: 1.237,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.838,
    cy: 22.487,
    rx: 1.228,
    ry: 1.237,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.032,
    cy: 36.987,
    rx: 1.228,
    ry: 1.237,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.647,
    cy: 48.316,
    rx: 1.229,
    ry: 1.237,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 57.353,
    r: 1.234,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.354,
    cy: 48.316,
    rx: 1.227,
    ry: 1.237,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.966,
    cy: 36.988,
    rx: 1.229,
    ry: 1.236,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.162,
    cy: 22.487,
    rx: 1.228,
    ry: 1.237,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.177,
    cy: 10.852,
    rx: 1.228,
    ry: 1.237,
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.aaafed1797ea4cf433957e2f675a193d.svg";
export { ForwardRef as ReactComponent };